/* global FB */

const facebookCommon = {
  getStatusCallback: (res, fetchData) => {
    console.log('facebookCommon.getStatusCallback::::', res)

    const scope = 'public_profile, email';

    if ('connected' === res.status) {
      return fetchData(res);
    }

    return FB.login(loginRes => {
    console.log('facebookCommon.getStatusCallback FB.login::::', res)
    if ('connected' === loginRes.status) {
        fetchData(loginRes);
      }
    }, { scope });
  },

  fetchData: (callback) => {
    console.log('facebookCommon.fetchData::::')

    FB.api('/me?fields=name,first_name,last_name,email,picture,work', callback);
  }
};

export default facebookCommon;
